import React, { useEffect, useRef } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import classNames from "classnames";
import Icon from "@ant-design/icons";
import { MenuItem } from "../../api/menu";
import { ExpandableKeys, WithBooleanFlag } from "../../store/core";
import menuStore from "../../store/menu";

import { MenuArrowIco } from "../../assets/customIcons";
import * as icons from "../../assets/customIcons";

import styles from "./Menu.module.scss";
import { toJS } from "mobx";

interface IMenuItem {
  item: MenuItem;
  expanded: boolean;
  menuIsCollapsed: boolean;
  level: number;
  idx: number;
  onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
  onMouseEnter: (e: React.MouseEvent<HTMLDivElement>) => void;
  onMouseLeave?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onCheckReset: () => void;
}

const MenuItemComponent = React.forwardRef<HTMLLIElement, IMenuItem>(
  (
    {
      item,
      expanded,
      menuIsCollapsed,
      level,
      idx,
      onClick,
      onMouseEnter,
      onMouseLeave,
      onCheckReset,
    },
    ref,
  ) => {
    const location = useLocation();
    const history = useHistory();

    const getUrlMenu = (str: string) => {
      if (!/^\//.test(str)) {
        return `/${str}`;
      } else {
        return str;
      }
    };

    const icon = () => icons[`${item.icon}Svg`];

    return (
      <li
        ref={ref}
        className={classNames(
          styles["menu__item"],
          expanded
            ? styles["menu__item--expanded"]
            : null,
          item.items.length > 0 ? styles["menu__item--has-border"] : null,
          level > 2 ? styles["menu__item--deepest"] : null,
          history.location?.pathname === item?.url
            ? styles["menu__item--url-active"]
            : null,
        )}
        onClick={onClick}
        onMouseEnter={onCheckReset}
        key={item?.name}
      >
        <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
          {icons[`${item.icon}Svg`] && level === 1 ? (
            <>
              {item?.url && item.items.length === 0 ? (
                <NavLink
                  exact
                  to={getUrlMenu(item?.url)}
                  className={styles["menu__item-icon-link"]}
                ></NavLink>
              ) : null}
              <Icon
                className={styles["menu__item-icon"]}
                component={icon}
                title={item?.name}
              />
            </>
          ) : null}
          <span
            className={classNames(
              styles["menu__item-label"],
              menuIsCollapsed
                ? styles["menu__item-label--collapsed"]
                : "not-collapsed",
            )}
          >
            {item?.url ? (
              <NavLink
                key={idx + location.key}
                exact
                to={getUrlMenu(item?.url)}
                className={styles["menu__item-label-text"]}
              >
                {item?.name}
              </NavLink>
            ) : (
              <span className={styles["menu__item-label-text"]}>
                {item?.name}
              </span>
            )}
            {/* TASK 1597
                    TODO: игнорируем ссылки с бэка, если список раскравающийся */}
            {/* условие для игнорирования ссылок с бэка, если это раскраывающийся список*/}
            {/* {!item?.items?.length ? (
                      <NavLink
                        key={index + location.key}
                        exact
                        activeClassName={styles.active}
                        to={getUrlMenu(item?.url)}
                        className={styles["menu__item-label-text"]}
                      >
                        {item?.name}
                      </NavLink>
                    ) : (
                      <span className={styles["menu__item-label-text"]}>
                        {item?.url}{item?.name}
                      </span>
                    )} */}
          </span>
          {/* условие для появление боковой стрелочки*/}
          {item.items.length ? (
            <i
              className={classNames(
                styles["menu__item-arrow"],
                menuIsCollapsed ? styles["menu__item-arrow--collapsed"] : null,
                level > 1 ? styles["menu__item-arrow--to-right"] : null,
              )}
            >
              <MenuArrowIco />
            </i>
          ) : null}
        </div>
      </li>
    );
  },
);

export default MenuItemComponent;
